import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { Inbox } from '../../../components/inbox/Inbox';

const inboxSearchSchema = z.object({
  threadId: z.string().uuid().optional(),
});

export const Route = createFileRoute('/_fullWidthLayout/inbox/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    const parsed = inboxSearchSchema.safeParse(search);

    return parsed.success ? parsed.data : {};
  },
});

function RouteComponent() {
  const { threadId } = Route.useSearch();

  return <Inbox initialThreadId={threadId} />;
}
